@if (clientReferralMatchVerifications.length > 0) {
  <div class="dates">
    @for (verification of clientReferralMatchVerifications; track verification; let i = $index) {
      <div class="my-2">
        <span>
          <strong>Client Referral Date {{ i + 1 }}</strong>
        </span>
        <div class="form-inline client-referral-match-verification">
          <div class="input-group client-referral-date">
            <input
              name="clientReferralDate"
              class="form-control client-referral-date-input"
              type="date"
              autocomplete="off"
              [(ngModel)]="verification.clientReferralDate"
              [disabled]="true"
              placeholder="MM/DD/YYYY"
              />
          </div>
        </div>
      </div>
    }
  </div>
} @else {
  <div class="my-2">No client referral dates found.</div>
}
